/**
 * @file Header.jsx
 * @description Header da aplicação
 * 
 * @exports Header - Componente do header
 */

import LogoBayer from '../../imgs/Logo_Bayer.png';
import LogoMIA from '../../imgs/Logo_MIA.png';
import LogoDTIT from '../../imgs/Logo_DTIT.png';
import './Header.css';

export const Header = () => {
  return (
    <header className="header">
      <div className="header__container">
        <div className="header__left">
          <div className="header__logo">
            <img src={LogoMIA} alt="Mia Logo" />
          </div>
          <h1 className="header__title">MIA - Content</h1>
        </div>
        <div className="header__right">
          <div className="header__logo-DTIT">
            <img src={LogoDTIT} alt="DT_IT Logo" />
          </div>
          <div className="header__logo-bayer">
            <img src={LogoBayer} alt="Bayer Logo" />
          </div>
        </div>
      </div>
    </header>
  );
};
